'use client'

import { useEffect } from 'react'
import Link from 'next/link'
import { AlertCircle, ChevronLeft, RotateCcw } from 'lucide-react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error for debugging
    console.error('[Gallery Error]', error)
  }, [error])

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-4">
        <Link
          href="/"
          className="flex items-center gap-1 text-sm font-medium text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-slate-50 w-fit"
        >
          <ChevronLeft className="h-4 w-4" />
          Back to Galleries
        </Link>
      </div>

      <div className="flex items-start gap-4 rounded-lg border border-red-200 bg-red-50 p-6 dark:border-red-900 dark:bg-red-950">
        <AlertCircle className="h-5 w-5 flex-shrink-0 text-red-600 dark:text-red-400 mt-0.5" />
        <div className="flex-1">
          <h2 className="text-lg font-semibold text-red-900 dark:text-red-100 mb-2">
            Failed to Load Gallery
          </h2>
          <p className="text-sm text-red-700 dark:text-red-300 mb-4">
            {error?.message || 'An error occurred while loading this gallery. This might be a temporary issue with our servers.'}
          </p>
          <div className="flex gap-3">
            <button
              onClick={() => reset()}
              className="flex items-center gap-2 rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 transition-colors dark:bg-red-700 dark:hover:bg-red-600"
            >
              <RotateCcw className="h-4 w-4" />
              Try Again
            </button>
            <Link
              href="/"
              className="flex items-center gap-2 rounded-md border border-red-300 px-4 py-2 text-sm font-medium text-red-600 hover:bg-red-50 transition-colors dark:border-red-700 dark:text-red-300 dark:hover:bg-red-900/20"
            >
              <ChevronLeft className="h-4 w-4" />
              Return Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
